export const isWordFile = (url) => /\.docx?(?:[?#]|$)/i.test(String(url || ''));

// Stored links name the backend host that took the upload. In prod that is the Cloud
// Run URL, not the API host the app calls, and some school web filters block it (or
// the storage host /files/handwritten redirects to) while they allow the API host.
// Each API host maps to the other names of the SAME backend, which reads the same
// bucket, so a link on one of them can be fetched from the API host instead.
// Links on any other host (another environment, an old service) keep their host.
// Prod has no aliases for now: Cloudflare hotlink protection on api.gojeddle.com
// answers image paths requested from go.jeddle.com with a 403, so prod previews
// stay on the Cloud Run host until that zone allows them.
const SAME_BACKEND_HOSTS = {
  'api.gojeddle.com': [],
};

const apiOrigin = () => {
  try {
    return new URL(
      process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8080'
    ).origin;
  } catch {
    return null;
  }
};

const onApiHost = (url) => {
  const api = apiOrigin();
  let origin;
  try {
    origin = new URL(url).origin;
  } catch {
    return url;
  }
  if (!api || !url.startsWith(origin)) return url;
  const aliases = SAME_BACKEND_HOSTS[new URL(api).host] || [];
  if (!aliases.includes(new URL(origin).host)) return url;
  return api + url.slice(origin.length);
};

// Stored URLs and explicit downloads keep their original route. Browser previews
// use API-streamed bytes, so they depend neither on the storage host being reachable
// nor on the GCS bucket's CORS policy (PDF.js). Legacy Word uploads retain their
// original; the preview route supplies a cached PDF. A .doc has no converted PDF
// (the preview route refuses it), so it keeps its stored link.
// Apply this where a URL is rendered or opened, never to URLs that are saved or
// compared: answers send their stored links back and match them by exact string.
export const filePreviewUrl = (url) => {
  if (typeof url !== 'string') return url;
  const path = url.split(/[?#]/, 1)[0];
  if (
    !/\/files\/handwritten\/[^/]+$/i.test(path) ||
    !/\.(?:docx|pdf|png|jpe?g|jfif|webp|gif|avif|bmp)$/i.test(path)
  )
    return url;
  return onApiHost(
    url.replace('/files/handwritten/', '/files/preview/handwritten/')
  );
};

export const canPreviewWord = (url) =>
  /\.docx(?:[?#]|$)/i.test(String(url || '')) &&
  String(url || '').includes('/files/preview/handwritten/');
